module.exports = __webpack_public_path__ + "static/media/HIWEanpayMoneyTransfer.d049c370.svg";